import {useLayoutEffect, useRef} from 'react';
import {animated, easings, useSpring} from 'react-spring';

import animationDurations from '../../consts/animation/animationDurations';
import useMeasuredHeight from '../../hooks/useMeasuredHeight';
import {twx} from '../../utils/tailwindUtils';

// animates towards the natural height of its content, so any change inside it - a swapped layer,
// a mounted panel - is picked up without the caller knowing a pixel value
export const AnimatedHeight = ({children, className}) => {
    const {measuredRef, heightPx} = useMeasuredHeight();
    // the first measurement is a mount, not a size change, so it is applied without animating
    const hasMeasuredRef = useRef(false);

    const style = useSpring({
        height: heightPx ?? 0,
        immediate: !hasMeasuredRef.current,
        config: {duration: animationDurations.STATE_CHANGE_MS, easing: easings.easeInOutCubic},
    });

    useLayoutEffect(() => {
        if (heightPx !== null) hasMeasuredRef.current = true;
    }, [heightPx]);

    return (
        <animated.div className={twx('overflow-hidden', className)} style={heightPx === null ? undefined : style}>
            <div ref={measuredRef}>{children}</div>
        </animated.div>
    );
};
